import { render, staticRenderFns } from "./ChartFromAi.vue?vue&type=template&id=2ff49a07&scoped=true"
import script from "./ChartFromAi.vue?vue&type=script&lang=js"
export * from "./ChartFromAi.vue?vue&type=script&lang=js"
import style0 from "./ChartFromAi.vue?vue&type=style&index=0&id=2ff49a07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff49a07",
  null
  
)

export default component.exports